<div class="coworking-funnel-container">
  <div class="stepper">
    <cowing-core-coworking-stepper
      [steps]="steps"
    ></cowing-core-coworking-stepper>
  </div>
  <div class="form">
    <cowing-core-coworking-info
      *ngIf="whatStepIsActive === 1"
      [form]="registerForm.get('generalForm')"
      (location)="setLocation($event)"
    ></cowing-core-coworking-info>

    <cowing-core-coworking-spaces
      *ngIf="whatStepIsActive === 2"
      [form]="registerForm.get('spacesForm')"
    >
    </cowing-core-coworking-spaces>

    <cowing-core-coworking-services
      *ngIf="whatStepIsActive === 3"
      [form]="registerForm.get('servicesForm')"
    >
    </cowing-core-coworking-services>

    <cowing-core-coworking-bank-info
      *ngIf="whatStepIsActive === 4"
      [form]="registerForm.get('paymentInfoForm')"
    >
    </cowing-core-coworking-bank-info>

    <cowing-core-coworking-confirm *ngIf="whatStepIsActive === 5">
    </cowing-core-coworking-confirm>
  </div>

  <div class="actions">
    <cowing-button
      [label]="
        isInitStep
          ? ('coworking.cancel' | translate)
          : ('coworking.back' | translate)
      "
      [type]="EButtonType.RoundedSecondary"
      [iconShow]="false"
      (event)="isInitStep ? goBack() : setPreviousStep($event)"
    ></cowing-button>
    <cowing-button
      [disabled]="isDisabledNextStep"
      [label]="isLastStep ? 'Entendido' : 'Continuar'"
      [type]="EButtonType.Rounded"
      [iconShow]="false"
      (event)="isLastStep ? confirmForm() : setNextStep($event)"
    >
    </cowing-button>
  </div>
</div>
